/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { UpgradeIneligibilityReason } from './';
import {
    UpgradeIneligibilityReasonFromJSON,
    UpgradeIneligibilityReasonFromJSONTyped,
    UpgradeIneligibilityReasonToJSON,
} from './';

/**
 * 
 * @export
 * @interface UpgradeEligibilityResource
 */
export interface UpgradeEligibilityResource {
    /**
     * 
     * @type {boolean}
     * @memberof UpgradeEligibilityResource
     */
    eligible: boolean;
    /**
     * 
     * @type {UpgradeIneligibilityReason}
     * @memberof UpgradeEligibilityResource
     */
    reason?: UpgradeIneligibilityReason;
}

/**
 * Check if a given object implements the UpgradeEligibilityResource interface.
 */
export function instanceOfUpgradeEligibilityResource(value: object): value is UpgradeEligibilityResource {
    if (!('eligible' in value) || value['eligible'] === undefined) return false;
    return true;
}

export function UpgradeEligibilityResourceFromJSON(json: any): UpgradeEligibilityResource {
    return UpgradeEligibilityResourceFromJSONTyped(json, false);
}

export function UpgradeEligibilityResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpgradeEligibilityResource {
    if (json == null) {
        return json;
    }
    return {
        
        'eligible': json['eligible'],
        'reason': json['reason'] == null ? undefined : UpgradeIneligibilityReasonFromJSON(json['reason']),
    };
}

export function UpgradeEligibilityResourceToJSON(value?: UpgradeEligibilityResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'eligible': value['eligible'],
        'reason': UpgradeIneligibilityReasonToJSON(value['reason']),
    };
}

